// extracted by mini-css-extract-plugin
export default {"root":"SelectSolutionTypeModal_root__YrMxP","container":"SelectSolutionTypeModal_container__hEsSF","cards":"SelectSolutionTypeModal_cards__jtkt2"};